import { render, staticRenderFns } from "./DNSMonitoringList.vue?vue&type=template&id=6e167496&scoped=true&"
import script from "./DNSMonitoringList.vue?vue&type=script&lang=js&"
export * from "./DNSMonitoringList.vue?vue&type=script&lang=js&"
import style0 from "./DNSMonitoringList.vue?vue&type=style&index=0&id=6e167496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e167496",
  null
  
)

export default component.exports